<template>
  <b-container fluid>
    <b-col class="no-sided-padding">
      <b-tabs ref="memberships-tab" v-model="tab" fill pills card>
        <div style="padding-top: 10px">
          <b-alert :show="showAlert" dismissible @dismissed="showAlert = false">
            La sezione Adesioni visualizza le adesioni ricevute da Tablet, Web App Conad e Operazioni di Digitalizzazione in ordine cronologico.
          </b-alert>
        </div>
        <b-tab title="Elenco">
          <b-row class="margin-top-md">
            <b-col cols="2">
              <b-card header-bg-variant="light">
                <template #header>
                  <div class="custom-card-header">
                    <strong>
                      <b-icon-funnel></b-icon-funnel>
                      Filtri</strong>
                  </div>
                </template>
                <b-card-body style="padding: 0.5rem">
                  <b-form @submit="retrieveMemberships" id="form">
                    <b-form-group label="Codice Tessera">
                      <b-form-input id="barcode" v-model="filters.barcode"/>
                    </b-form-group>
                    <b-form-group label="Filiale">
                      <ShopSelect ref="shop" v-model="shopSelected"/>
                    </b-form-group>

                    <b-form-group label="Cognome">
                      <b-form-input id="surname" v-model="filters.surname"/>
                    </b-form-group>

                    <b-form-group label="Nome">
                      <b-form-input id="name" v-model="filters.name"/>
                    </b-form-group>

                    <b-form-group label="Data di inizio">
                      <DatePicker ref="startDate" v-model="filters.startDate" id="start-date" :required="false"/>
                    </b-form-group>
                    <b-form-group label="Data di fine">
                      <DatePicker ref="endDate" v-model="filters.endDate" id="end-date" :required="false"/>
                    </b-form-group>

                    <b-form-group>
                      <b-button type="submit" variant="primary" block id="search">
                        <span v-show="showSpinner" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        <b-icon-search/>&nbsp;Cerca
                      </b-button>
                    </b-form-group>
                  </b-form>
                </b-card-body>
              </b-card>
              <b-card header-bg-variant="light" class="margin-top-md">
                <template #header>
                  <div class="custom-card-header">
                    <strong>
                      <b-icon-file-earmark-arrow-down/>
                      Esportazione</strong>
                  </div>
                </template>
                <Export />
              </b-card>
            </b-col>
            <b-col cols="10">
              <b-card header-bg-variant="light">
                <template #header>
                  <div style="height: 1.5rem">
                    <span><strong><b-icon-card-checklist/>&nbsp;Adesioni trovate</strong></span>
                  </div>
                  <div v-if="searched" class="float-right">
                    <h6 v-show="!isEmpty(confirmedFilters)" class="filters-list-head">
                      Filtri applicati:
                      <b-badge class="filter-badge" v-show="confirmedFilters.barcode" @click="removeFilter('barcode')" variant="info" pill tag="button">Codice tessera:
                        <i>{{ confirmedFilters.barcode }}</i>&nbsp;<b-icon-x-circle-fill
                          variant="light"/>
                      </b-badge>
                      <b-badge class="filter-badge" v-show="confirmedFilters.shopCode" @click="removeFilter('shopCode')" variant="info" pill tag="button">Codice Filiale:
                        <i>{{ confirmedFilters.shopCode }}</i>&nbsp;<b-icon-x-circle-fill
                          variant="light"/>
                      </b-badge>
                      <b-badge class="filter-badge" v-show="confirmedFilters.surname" @click="removeFilter('surname')" variant="info" pill tag="button">Cognome:
                        <i>{{ confirmedFilters.surname }}</i>&nbsp;<b-icon-x-circle-fill
                          variant="light"/>
                      </b-badge>
                      <b-badge class="filter-badge" v-show="confirmedFilters.name" @click="removeFilter('name')" variant="info" pill tag="button">Nome:
                        <i>{{ confirmedFilters.name }}</i>&nbsp;<b-icon-x-circle-fill
                          variant="light"/>
                      </b-badge>
                      <b-badge class="filter-badge" v-show="confirmedFilters.startDate" @click="removeFilter('startDate')" variant="info" pill tag="button">Data Inizio:
                        <i>{{ asISODate(confirmedFilters.startDate) }}</i>&nbsp;<b-icon-x-circle-fill
                          variant="light"/>
                      </b-badge>
                      <b-badge class="filter-badge" v-show="confirmedFilters.endDate" @click="removeFilter('endDate')" variant="info" pill tag="button">Data Fine:
                        <i>{{ asISODate(confirmedFilters.endDate) }}</i>&nbsp;<b-icon-x-circle-fill
                          variant="light"/>
                      </b-badge>
                    </h6>
                  </div>
                </template>
                <b-card-body>
                  <MembershipList v-model="membershipList" :canDelete="canDelete()"/>
                </b-card-body>
              </b-card>
              <b-pagination
                align="left"
                v-model="currentPage"
                @change="showPage"
                :per-page="pageSize"
                :total-rows="totalRows"
              ></b-pagination>
            </b-col>

          </b-row>
        </b-tab>
        <b-tab title="Dettaglio Adesione">
          <Details :modifiable="false"></Details>
        </b-tab>
      </b-tabs>
    </b-col>
    <div style="float: right">
      <p style="font-size: 11px">Powered by <img width="100px" src="../assets/CherryChainLogo.png" alt="CherryChain"></p>
    </div>
  </b-container>
</template>

<script>
import MembershipList from "../components/memberships/MembershipList";
import MembershipApi from "../api/MembershipApi";
import DatePicker from "../components/DatePicker";
import Export from "../views/Export";
import Vue from 'vue'
import ShopSelect from '../components/ShopSelect'
import eventBus from "../EventBus";
import Details from '@/components/memberships/Details'

import {BFormDatepicker} from 'bootstrap-vue'
import moment from "moment/moment";

Vue.component('b-form-datepicker', BFormDatepicker)

export default {
  name: 'Memberships',
  props: ['session'],
  provide() {
    return {parentValidator: this.$validator}
  },
  components: {MembershipList, DatePicker, ShopSelect, Export, Details},
  data: () => ({
    showAlert: false,
    showNext: false,
    membershipList: [],
    currentPage: 1,
    pageSize: null,
    totalRows: null,
    shopSelected: null,
    filters: {
      shopCode: null,
      startDate: null,
      endDate: null
    },
    searched: false,
    confirmedFilters: {},
    showSpinner: false,
    startDate: null,
    endDate: null,
    isDownloading: false,
    tab: 0,
    membership: null,
  }),
  mounted() {
    eventBus.$on("shop-selected", res => {
      this.filters.shopCode = res
    })
    eventBus.$on("membership-detail", (() => {
      this.tab = 1
    }))
    eventBus.$on("show-alert", () => {
      this.showAlert = true
    })
    this.retrieveMemberships()
  },
  beforeDestroy() {
    eventBus.$off("shop-selected")
  },
  methods: {
    today() {
      return new Date().toDateString()
    },
    asISODate: date => moment(date).format('DD/MM/YYYY'),
    retrieveMemberships(event) {
      if (event) event.preventDefault()

      if (this.filters.barcode) this.filters.barcode = this.filters.barcode.replace(/\s/g, '')

      this.membershipList = []
      this.showPage(1)
    },
    showPage(number) {
      this.showSpinner = true
      this.searched = true
      if (this.filters.barcode) this.confirmedFilters.barcode = this.filters.barcode
      if (this.filters.shopCode) this.confirmedFilters.shopCode = this.filters.shopCode
      if (this.filters.surname) this.confirmedFilters.surname = this.filters.surname
      if (this.filters.name) this.confirmedFilters.name = this.filters.name
      if (this.filters.startDate) this.confirmedFilters.startDate = this.filters.startDate
      if (this.filters.endDate) this.confirmedFilters.endDate = this.filters.endDate

      MembershipApi
        .membershipList({...this.filters, page: number})
        .then(result => {
          this.membershipList = result.data.previews

          this.showNext = result.data.length > 0
          this.showSpinner = false

          this.pageSize = result.data.pageSize
          this.totalRows = result.data.pageCount*this.pageSize
        })
        .catch(err => console.error(`Error requesting memberships: ${err}`))
    },
    removeFilter(field) {
      console.log(this.confirmedFilters)
      delete this.confirmedFilters[field]
      delete this.filters[field]

      if (field === 'startDate') {
        this.$refs.startDate.reset()
      }
      if (field === 'endDate') {
        this.$refs.endDate.reset()
      }

      if(field === 'shopCode') {
        this.$refs.shop.reset()
      }

      this.retrieveMemberships()
    },
    isEmpty(object) { return Object.keys(object).length === 0 },
    canDelete() {
      return this.session.tokenParsed.realm_access.roles.includes("membership_deletion")
    }
  }
}
</script>

<style>
</style>
